import "./ContestPreviousWinnerRow.scss"
import { gettext, usernameTitleCase } from "@multimediallc/web-utils"
import { Sizes, Weights } from "../../../interfaces/sizing"
import { Flex, Link, Typography } from "../../common"
import type { IPreviousWinner } from "../ContestPreviousWinners/ContestPreviousWinners"

type ContestPreviousWinnerRowProps = IPreviousWinner

const i18n = {
    unclaimedPrizeText: gettext("Unclaimed Prize"),
    prizeText: gettext("Prize"),
}

export function ContestPreviousWinnerRow({
    username,
    time,
    prize_amount,
    image_url,
}: ContestPreviousWinnerRowProps) {
    const isUnclaimed = username === undefined
    return (
        <>
            <Flex
                direction="row"
                align="center"
                justify="start"
                wrap={false}
                className="ContestPreviousWinnerRow"
            >
                <Typography
                    size={Sizes.sm}
                    className="timeContainer rowContainer"
                >
                    {time}
                </Typography>
                {isUnclaimed ? (
                    <Typography
                        className="rowContainer unclaimed"
                        size={Sizes.md}
                    >
                        {i18n.unclaimedPrizeText}
                    </Typography>
                ) : (
                    <>
                        <Link href={`/${username}/`} className="rowContainer">
                            <img
                                width={52}
                                height={52}
                                alt="broadcaster-snapshot"
                                src={image_url}
                            />
                        </Link>
                        <div className="rowContainer">
                            <Link
                                href={`/${username}/`}
                                className="usernameText"
                            >
                                <Typography
                                    size={Sizes.lg}
                                    weight={Weights.medium}
                                    color=""
                                >
                                    {usernameTitleCase(username)}
                                </Typography>
                            </Link>
                            <Typography size={Sizes.xs} className="pointsText">
                                {`${i18n.prizeText}: ${prize_amount}`}
                            </Typography>
                        </div>
                    </>
                )}
            </Flex>
            <hr className="previousWinnerEndLine" />
        </>
    )
}
